import { render, staticRenderFns } from "./partyGroupConfigDetail.vue?vue&type=template&id=5854fa72&scoped=true"
import script from "./partyGroupConfigDetail.vue?vue&type=script&lang=js"
export * from "./partyGroupConfigDetail.vue?vue&type=script&lang=js"
import style0 from "./partyGroupConfigDetail.vue?vue&type=style&index=0&id=5854fa72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5854fa72",
  null
  
)

export default component.exports